export const colorThemes = [
  {
    name: 'brightWhite',
    colors: {
      primary: '#fff',
      secondary: '#eee',
      accent: '#777',
      text: '#464341'
    },
    brightness: 'light'
  },
  {
    name: 'deepGray',
    colors: {
      primary: '#2f2b2b',
      secondary: '#444',
      accent: '#f3f0f0',
      text: '#fff'
    },
    brightness: 'dark'
  },
  {
    name: 'deepSea',
    colors: {
      primary: '#473ea2',
      secondary: '#514dad',
      accent: '#ff94fc',
      text: '#fff'
    },
    brightness: 'dark'
  },
  {
    name: 'Lilly',
    colors: {
      primary: '#EBB4AC',
      secondary: '#E1776C',
      accent: '#315775',
      text: '#2C2437'
    },
    brightness: 'light'
  },
  {
    name: 'Lilly Invert',
    colors: {
      primary: '#2C2437',
      secondary: '#315775',
      accent: '#E1776C',
      text: '#EBB4AC'
    },
    brightness: 'dark'
  },
  {
    name: 'retroPinapple',
    colors: {
      primary: '#85a392',
      secondary: '#f5b971',
      accent: '#fdd998',
      text: '#ffecc7'
    },
    brightness: 'light'
  },
  {
    name: 'Light Leaves',
    colors: {
      primary: '#EBEBE9',
      secondary: '#E3E6DA',
      accent: '#8AA989',
      text: '#49654C'
    },
    brightness: 'light'
  },
  {
    name: 'Dark Leaves',
    colors: {
      primary: '#49654C',
      secondary: '#8AA989',
      accent: '#E3E6DA',
      text: '#EBEBE9'
    },
    brightness: 'dark'
  },
  {
    name: 'purpleSunset',
    colors: {
      primary: '#511845',
      secondary: '#900c3f',
      accent: '#c70039',
      text: '#ff5733'
    },
    brightness: 'dark'
  },
  {
    name: 'Rainbow Palm',
    colors: {
      primary: '#758F9C',
      secondary: '#B3D4DA',
      accent: '#F7ECE9',
      text: '#FAF9F1'
    },
    brightness: 'dark'
  },
  {
    name: 'Rainbow Palm Invert',
    colors: {
      primary: '#FAF9F1',
      secondary: '#F7ECE9',
      accent: '#B3D4DA',
      text: '#758F9C'
    },
    brightness: 'light'
  },
  {
    name: 'Dark Lilac',
    colors: {
      primary: '#67626C',
      secondary: '#94939A',
      accent: '#AE999F',
      text: '#DAD5DC'
    },
    brightness: 'dark'
  },
  {
    name: 'Bright Lilac',
    colors: {
      primary: '#DAD5DC',
      secondary: '#AE999F',
      accent: '#94939A',
      text: '#67626C'
    },
    brightness: 'light'
  },
  {
    name: 'unicornMagic',
    colors: {
      primary: '#efa8e4',
      secondary: '#f8e1f4',
      accent: '#97e5ef',
      text: '#fff0f5'
    },
    brightness: 'light'
  },
  {
    name: 'seaTurtle',
    colors: {
      primary: '#204051',
      secondary: '#3b6978',
      accent: '#e1f4f3',
      text: '#cae8d5'
    },
    brightness: 'dark'
  },
  {
    name: 'darkCamo',
    colors: {
      primary: '#333333',
      secondary: '#706c61',
      accent: '#ffffff',
      text: '#e1f4f3'
    },
    brightness: 'dark'
  },
  {
    name: 'fadedSunrise',
    colors: {
      primary: '#fcf8e8',
      secondary: '#ecdfc8',
      accent: '#ecb390',
      text: '#df7861'
    },
    brightness: 'light'
  },
  {
    name: 'paleWatermelon',
    colors: {
      primary: '#f67280',
      secondary: '#c06c84',
      accent: '#6c5b7b',
      text: '#355c7d'
    },
    brightness: 'light'
  },
  {
    name: 'blueSteel',
    colors: {
      primary: '#143a52',
      secondary: '#6e828a',
      accent: '#e3eff3',
      text: '#cde3eb'
    },
    brightness: 'dark'
  },
  {
    name: 'RedAndBlue',
    colors: {
      primary: '#1e2759', // pptx navy grab,  '#001F5C' // navy
      secondary: '#313BFB', // blue
      accent: '#FF2E18', // red
      text: '#fff' // white
    },
    brightness: 'dark'
  },
  {
    name: 'RedAndBlue Invert',
    colors: {
      primary: '#fff', // white
      secondary: '#FF2E18', // red
      accent: '#313BFB', // blue
      text: '#1e2759' // pptx navy grab,  '#001F5C' // navy
    },
    brightness: 'light'
  }
  // {
  //   name: 'USAManilla',
  //   colors: {
  //     primary: '#F5F2D6', // manilla
  //     secondary: '#313BFB', // blue
  //     accent: '#FF2E18', // red
  //     text: '#1e2759' // pptx navy grab,  '#001F5C' // navy
  //   },
  //   brightness: 'light'
  // },
  // {
  //   name: 'USABlue',
  //   colors: {
  //     primary: '#313BFB', // blue
  //     secondary: '#1e2759', // pptx navy grab,  '#001F5C' // navy
  //     accent: '#F5F2D6', // manilla
  //     text: '#fff' // white
  //   },
  //   brightness: 'dark'
  // }
]

// FONTS //

export const fontPairs = [
  {
    name: 'Open Sans',
    title: 'Open Sans',
    paragraph: 'Open Sans'
  },
  {
    name: 'Playfair + Source Sans',
    title: 'Playfair Display',
    paragraph: 'Source Sans Pro'
  },
  {
    name: 'Clicker Script + Roboto',
    title: 'Clicker Script',
    paragraph: 'Roboto'
  },
  {
    name: 'Montserrat + Merriweather',
    title: 'Montserrat',
    paragraph: 'Merriweather'
  },
  {
    name: 'Bangers + Source',
    title: 'Bangers',
    paragraph: 'Source Sans Pro'
  },
  {
    name: 'Elsie',
    title: 'Elsie',
    paragraph: 'Open Sans'
  },
  {
    name: 'Libre Baskerville',
    title: 'Libre Baskerville',
    paragraph: 'Hind'
  },
  {
    name: 'Caveat Brush + Roboto',
    title: 'Caveat Brush',
    paragraph: 'Roboto'
  },
  {
    name: 'Sedgwick Ave Display',
    title: 'Sedgwick Ave Display',
    paragraph: 'Open Sans'
  },
  {
    name: 'Palanquin Dark',
    title: 'Palanquin Dark',
    paragraph: 'Merriweather'
  },
  {
    name: 'Raleway + Open Sans',
    title: 'Raleway',
    paragraph: 'Open Sans'
  },
  {
    name: 'Merriweather + Montserrat',
    title: 'Merriweather',
    paragraph: 'Montserrat'
  },
  {
    name: 'Dancing Script + Open Sans',
    title: 'Dancing Script',
    paragraph: 'Open Sans'
  },
  {
    name: 'Abril + Roboto',
    title: 'Abril Fatface',
    paragraph: 'Roboto'
  }
]

export const defaultThemeData = {
  colors: colorThemes[0],
  fonts: {},
  background: {}
}
